import React, { Component } from "react";
import FilteredCards from "./FilteredCards";



class CardGallery extends Component {

  render() {
    var cardGalleryWrapperStyle ={
          display: this.props.display

    }

    var cardGalleryStyle70 = {
    backgroundColor: "black",
    overflowY: "scroll",
    height: "100vh"
    }

    var cardGalleryStyle100 = {
      backgroundColor: "black",
    }


    return (
      <div className="container-fluid" id="cardGalleryWrapper" style={cardGalleryWrapperStyle}>
        <div className="d-flex flex-row flex-wrap" id="cardGallery" style={this.props.width === "100%" ? cardGalleryStyle100 : cardGalleryStyle70}>

            <FilteredCards cards={this.props.cards} clickHandler={this.props.clickHandler}/>

        </div>
      </div>
    );
  }
}

export default CardGallery;



// WEBPACK FOOTER //
// ./src/DeckBuilderComponents/CardGallery.js